import React from "react";
import { Button } from "antd";
import { ButtonProps } from "antd/es/button";

interface Props extends ButtonProps {
    children: React.ReactNode;
}

const Index = ({ children, ...props }: Props) => {
    return (
        <Button type="link" {...props}>
            {children}
        </Button>
    );
};

export default Index;
